import type { Components, Theme } from '@mui/material/styles'

import { spacing } from '@/themes/tokens'

export const MuiTextFieldOverride: Components<Theme>['MuiTextField'] = {
  defaultProps: {
    variant: 'outlined',
    size: 'medium',
    fullWidth: true
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiOutlinedInput-root': {
        borderRadius: theme.spacing(spacing.sm)
      },
      '& .MuiInputLabel-root': {
        fontSize: '0.875rem'
      }
    })
  },
  variants: [
    {
      props: { size: 'medium' },
      style: ({ theme }) => ({
        '& .MuiOutlinedInput-input': {
          padding: theme.spacing(spacing.input)
        }
      })
    }
  ]
}
